/** The monthly price for putting a site live, as shown in copy. */
export const MONTHLY_PRICE = "£6.99";
